module.exports = __webpack_public_path__ + "static/img/ico_user_arrow.acaab2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico_user_arrow.png
// module id = Fto5
// module chunks = 1